import { render, staticRenderFns } from "./menu_user_company_component.vue?vue&type=template&id=3096793a"
import script from "./menu_user_company_component.vue?vue&type=script&lang=js"
export * from "./menu_user_company_component.vue?vue&type=script&lang=js"
import style0 from "./menu_user_company_component.vue?vue&type=style&index=0&id=3096793a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports